// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sun-progress[data-v-5774658f]{width:100%;position:relative}.sun-progress .triangle-box[data-v-5774658f]{color:#fff;width:40px;text-align:center;padding:4px 0;border-radius:4px;margin-top:10px;position:relative;font-size:12px}.sun-progress .triangle-box .triangle[data-v-5774658f]{width:0;height:0;position:absolute;top:-8px;left:16px;border-left:4px solid transparent;border-right:4px solid transparent}", ""]);
// Exports
module.exports = exports;
